define('vspot-angular/services/pledge-service',[], function () {
    'use strict';

    return ['resources.Pledge', function (Pledge) {

        return {
            /*
             *  Save pledge data
             *
             *  @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: { status: boolean }
             */
            save: function(postData) {
                return Pledge.save(postData);
            }
        };
    }];
});

